import { AddressingConfigurationRuleResponseDto } from '@tiendanube/common';
import { ADDRESSING_RULES_TYPES } from './constants';

/**
 * @deprecated this function will not be necessary in v2
 */
export const reprioritizeRules = (
  rules: AddressingConfigurationRuleResponseDto[],
): AddressingConfigurationRuleResponseDto[] => {
  const appRules = rules
    .filter((rule) => rule.type === ADDRESSING_RULES_TYPES.APP)
    .map((rule, index) => ({ ...rule, priority: index }));

  const materializationRules = rules
    .filter((rule) => rule.type === ADDRESSING_RULES_TYPES.MATERIALIZE)
    .map((rule, index) => ({
      ...rule,
      priority: appRules.length + index,
    }));

  const otherRules = rules
    .filter(
      (rule) =>
        rule.type !== ADDRESSING_RULES_TYPES.APP &&
        rule.type !== ADDRESSING_RULES_TYPES.MATERIALIZE,
    )
    .map((rule, index) => ({
      ...rule,
      priority: appRules.length + materializationRules.length + index,
    }));

  return [...appRules, ...materializationRules, ...otherRules];
};

export const getEnabledRules = (
  rules: AddressingConfigurationRuleResponseDto[],
): AddressingConfigurationRuleResponseDto[] =>
  rules.filter((rule) => rule.enabled);

export const findRuleByType = (
  rules: AddressingConfigurationRuleResponseDto[],
  type: string,
): AddressingConfigurationRuleResponseDto | undefined =>
  rules.find((rule) => rule.type === type);

export const changeAppRule = (
  rules: AddressingConfigurationRuleResponseDto[],
  appCode?: string,
) =>
  rules.map((rule) =>
    rule.type === ADDRESSING_RULES_TYPES.APP && rule.code !== appCode
      ? { ...rule, enabled: false }
      : rule,
  );

export const changeTiebreakerRule = (
  rules: AddressingConfigurationRuleResponseDto[],
  value: boolean,
  isPriority: boolean,
) =>
  rules.map((rule) =>
    (isPriority && rule.type === ADDRESSING_RULES_TYPES.CD_PROXIMITY) ||
    (!isPriority && rule.type === ADDRESSING_RULES_TYPES.CD_PRIORITY)
      ? { ...rule, enabled: !value }
      : rule,
  );
